module.exports = __webpack_public_path__ + "img/bg1.d34f4302.png";